export const getStyled = (
  theme,
  isActive,
  isManagementActive,
  managementHover,
) => ({
  listItem: {
    height: '44px',
    width: 'auto',

    '&:hover': {
      color: '#fff',
    },
  },

  listItemText: {
    fontSize: '14px',
    color: theme.palette.mode === 'light' ? '#666' : '#FFF',
  },

  iconHoverActive: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    height: 36,
    width: 36,
    backgroundColor:
      theme.palette.mode === 'light'
        ? !isActive
          ? theme.custom.colors.defaultBackground
          : theme.palette.primary.main
        : !isActive
          ? '#213445'
          : theme.palette.primary.main,

    color:
      theme.palette.mode === 'light' ? (!isActive ? '#666' : '#FFF') : '#FFF',

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
    '& .MuiSvgIconRoot': {
      fontSize: '1.4rem',
    },
  },

  iconDashboardHoverActive: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    height: 36,
    width: 36,
    backgroundColor:
      theme.palette.mode === 'light'
        ? !isManagementActive || !managementHover
          ? theme.custom.colors.defaultBackground
          : theme.palette.primary.main
        : !isManagementActive || !managementHover
          ? '#213445'
          : theme.palette.primary.main,

    color:
      theme.palette.mode === 'light'
        ? !isManagementActive || !managementHover
          ? '#666'
          : '#FFF'
        : '#FFF',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
    '& .MuiSvgIconRoot': {
      fontSize: '1.4rem',
    },
  },

  text: {
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#15202B',
    color: theme.palette.mode === 'light' ? '#15202B' : '#FFF',
  },

  badge: {
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
});

export const getLayoutStyled = (theme) => ({
  root: {
    display: 'flex',
    height: '100vh',

    '@media (maxWidth: 600px)': {
      height: 'calc(100vh - 56px)',
    },

    backgroundColor: theme.custom.colors.fancyBackground,
    '& .MuiButtonOutlinedPrimary': {
      color: theme.palette.primary.main,
      border:
        theme.mode === 'light'
          ? '1px solid #181c35'
          : '1px solid rgba(255, 255, 255, 0.5)',
    },
    '& .MuiTabTextColorPrimary.MuiSelected': {
      color: theme.palette.primary.main,
    },
    fontFamily: 'Tahoma, sans-serif !important',
  },

  chip: {
    background: 'red',
    color: 'white',
  },

  avatar: {
    width: '100%',
  },

  avatarActive: {
    backgroundColor: 'transparent',
  },
  avatarHover: {
    backgroundColor: 'transparent',
  },

  toolbar: {
    paddingRight: 24,
    color: theme.custom.colors.dark,
    background: theme.custom.colors.barraSuperior,
  },

  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    padding: '0 6px',
    minHeight: '48px',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#15202B',

    '@media (maxWidth: 600px)': {
      height: '48px',
    },

    fontFamily: 'Tahoma, sans-serif',
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  appBarShift: {
    width: `calc(100% - 240px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    '@media (maxWidth: 600px)': {
      display: 'none',
    },
  },

  menuButtonHidden: {
    display: 'none',
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    color: 'white',
  },

  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: 240,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    overflowY: 'hidden',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#15202B',
  },

  drawerPaperClose: {
    overflowX: 'hidden',
    overflowY: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),

    '@media (maxWidth: 600px)': {
      width: theme.spacing(9),
    },
  },

  appBarSpacer: {
    minHeight: '48px',
  },

  content: {
    flex: 1,
    overflow: 'auto',
  },

  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },

  containerWithScroll: {
    flex: 1,
    overflowY: 'scroll',
    overflowX: 'hidden',
    ...theme.custom.scrollbarStyles,
    borderRadius: '8px',
    border: '2px solid transparent',
    '&::WebkitScrollbar': {
      display: 'none',
    },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },

  avatar2: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: 'pointer',
    borderRadius: '50%',
    //border: '2px solid #ccc',
    marginLeft: '10px',
  },

  updateDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  iconAccount: {
    display: 'flex',
    position: 'relative',
    top: '-2px',
    marginRight: '5px',
    color: theme.custom.colors.text,
  },

  menuItemCenter: {
    display: 'flex',
    justifyContent: 'center',
    padding: '5px 15px',
  },

  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.custom.colors.dark}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
});
